import * as React from 'react';
import { useEffect } from 'react';

const OktaLogout = () => { 
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    useEffect(() => {
        sessionStorage.removeItem("UserInfo");
        sessionStorage.removeItem("root");
        sessionStorage.removeItem('QueryTag');
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }
 
    }, []); 

    return (
        <div id="preloader">
            <div className="loading-text">You have been successfully logged out!</div>
        </div>
    );
};

export default OktaLogout;
